import React from "react";
import Supported from "../../assets/img/supported.jpg";
import "../WhatDrivesUs.css";

export default function SupportedLivingBanner() {
  return (
    <div className="wd-img top-img">
            <img src={Supported} alt="Care Team" />
          </div>
  );
}